<app-header></app-header>
<div class="tracker-detail pt0">
    <app-step-progress-bar [wizardSteps]="steps" [stepName]="activeStepName" [stepCompleted]="activeStepCompleted">
    </app-step-progress-bar>
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="innercard">
                    <h3 class="font24 clrblue mb10 center" translate>lblCurrentOffer</h3>
                    <div class="mt40 cmnform ml10 mr10">
                        <div class="row  xsmb20">
                            <div class="panel panel-default  w100">
                                <div class="panel-body">
                                    <div class=" text-center">
                                        <div class="bold font18" translate>lblFantasticOffer</div>

                                        <ul class="listing-st-1 licontentcenter nobefore">
                                            <li class="mt5 order-txt bordernone flcolumn pl0 flmid justify-content-center">

                                                <div class="flmid">
                                                    <span class="mr10 semibold textnormal" translate>lblNot</span>
                                                    <div class="onoffswitch">
                                                        <input #myOffer type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" id="myonoffswitch" (click)="contactUser(isNotificationforservice)" />
                                                        <label class="onoffswitch-label" for="myonoffswitch">
                                                            <span class="onoffswitch-inner"></span>
                                                            <span class="onoffswitch-switch"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <span class="ml10 semibold textnormal" translate>lblYes</span>
                                            </li>
                                        </ul>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="bottomaction">
    <div class="container">
        <div class="row">
            <div class="col-auto ml-auto">
        <a href="javascript:void(0);" (click)="moveNext();" class="btn btn-primary btn-lg minwidth"><span translate>lblNext</span></a>
        </div>
        </div>
    </div>
</div>